import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isNullOrUndefined, PaymentAccountUtil } from '@uzurv/rideWss/app/util';
import { PaymentState } from './payment.state';

export const paymentState = createFeatureSelector<PaymentState>('payment');

export const getPaymentAccounts = createSelector(paymentState, (state: PaymentState) => state.paymentAccounts);

export const getActivePaymentAccounts = createSelector(paymentState, (state: PaymentState) =>
  state.paymentAccounts.filter(paymentAccount => !PaymentAccountUtil.isPaymentAccountExpired(paymentAccount) && paymentAccount.verified)
);

export const getLastUsedPaymentAccount = createSelector(paymentState, (state: PaymentState) => state.lastUsedPaymentAccount);

export const getUnverifiedPaymentAccounts = createSelector(paymentState, (state: PaymentState) =>
  state.paymentAccounts.filter(paymentAccount => !PaymentAccountUtil.isPaymentAccountExpired(paymentAccount) && !paymentAccount.verified)
);

export const getExpiredPaymentAccounts = createSelector(paymentState, (state: PaymentState) =>
  state.paymentAccounts.filter(paymentAccount => PaymentAccountUtil.isPaymentAccountExpired(paymentAccount))
);

export const getPaymentAccountById = (paymentAccountId: number) =>
  createSelector(paymentState, (state: PaymentState) => {
    return state.paymentAccounts.find(paymentAccount => {
      return paymentAccount.id === paymentAccountId;
    });
  });

export const getPaymentMethods = createSelector(paymentState, (state: PaymentState) => state.paymentMethods);

export const getCardTypes = createSelector(paymentState, (state: PaymentState) => state.cardTypes);

export const getPaymentAccountsLoading = createSelector(paymentState, (state: PaymentState) => state.paymentAccountsLoading);

export const getPaymentAccountsRefreshing = createSelector(paymentState, (state: PaymentState) => state.paymentAccountsRefreshing);

export const getPaymentMethodsLoading = createSelector(paymentState, (state: PaymentState) => state.paymentMethodsLoading);

export const getCardTypesLoading = createSelector(paymentState, (state: PaymentState) => state.cardTypesLoading);

export const getLatestChargeOrder = createSelector(paymentState, (state: PaymentState) =>
  !isNullOrUndefined(state.paymentAccounts) && state.paymentAccounts.length > 0
    ? state.paymentAccounts[state.paymentAccounts.length - 1].chargeOrder
    : 0
);

export const getEarliestChargeOrder = createSelector(paymentState, (state: PaymentState) =>
  !isNullOrUndefined(state.paymentAccounts) && state.paymentAccounts.length > 0 ? state.paymentAccounts[0].chargeOrder : 0
);

export const getDefaultPaymentAccount = createSelector(paymentState, (state: PaymentState) =>
  !isNullOrUndefined(state.paymentAccounts) && state.paymentAccounts.length > 0 ? state.paymentAccounts[0] : null
);

export const isOutstandingChargesLoaded = createSelector(paymentState, state => state.isOutstandingChargesLoaded);

export const getOutstandingCharges = createSelector(paymentState, state => state.outstandingCharges);

export const isPaymentAccountActionInProgress = createSelector(
  paymentState,
  (state: PaymentState) => state.isPaymentAccountActionInProgress
);
